import type { TFunction } from 'i18next';
import type { U2000DeleteHandlersReturn } from '../../../u2000Core/hooks/handler/U2000UseDeleteHandlers';
import U2000DeleteRecordDialog from '../../../u2000Core/components/dialog/U2000DeleteRecordDialog';
import type { U3303HolidayYearSearchRow } from '../../U3303Service';

interface U3303HolidayYearDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn<U3303HolidayYearSearchRow>;
  t: TFunction;
  NS: string;
}

function U3303HolidayYearDeleteDlg({ handleDelete, t, NS }: U3303HolidayYearDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  const rows = handleDelete.selectedRows();
  const count = rows.length;

  return (
    <U2000DeleteRecordDialog
      isOpen={handleDelete.isDialogDeleteOpen}
      onClose={handleDelete.handleDeleteCloseDlg}
      title={t('lblDeleteDlgTitle', { ns: NS })}
    >
      <p className="mb-4">
        {t(count === 1 ? 'msgDeleteHolidayYear' : 'msgDeleteHolidayYear_other', {
          count,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {rows.map((row, index, array) => (
          <span key={row.id} className="inline-block text-gray-800">
            {String(row.year)}
            {index < array.length - 1 && ', '}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3303HolidayYearDeleteDlg;
